const disableSearchButton = () => {
  const searchInput = document.querySelector(".search-input #query");
  const searchButton = document.querySelector(".search-button");
  if (searchInput && searchButton) {
    if (searchInput.value === "") {
      searchButton.disabled = true;
    }
  }
}

const enableSearchButton = () => {
  const searchInput = document.querySelector(".search-input #query");
  const searchButton = document.querySelector(".search-button");
  if (searchInput && searchButton) {
    searchInput.addEventListener("input", function() {
      if (searchInput.value !== "") {
        searchButton.disabled = false;
      } else {
        searchButton.disabled = true;
      }
    });
  }
}

export { disableSearchButton };
export { enableSearchButton };
